import { ConcreteEncodable } from "./ConcreteEncodable";

import { SysCtrlEventImplEncoder } from "../../encoder/SysCtrlEventImplEncoder";

import * as CubiqTS from "../../index";
import { SysCtrlEvent } from "../SysCtrlEvent";

export class SysCtrlEventImpl extends ConcreteEncodable implements SysCtrlEvent {
  public static enType: string = "com.bcdfx.model.SysCtrlEventImpl";

  /*FID=1*/
  public systemControl: CubiqTS.SystemControl | null = null;
  /*FID=2*/
  public reason: string;
  /*FID=3*/
  public userCd: string;
  /*FID=100*/
  public messageId: string;
  public sessionOnly: string;

  constructor() {
    super();
    this.encoder = SysCtrlEventImplEncoder.Instance;
    this.setEncodableType(SysCtrlEventImpl.enType);
    //Model
  }

  public toString(): string {
    return (
      "SysCtrlEventImpl[" +
      "systemControl=" +
      this.systemControl +
      "reason=" +
      this.reason +
      "userCd=" +
      this.userCd +
      "messageId=" +
      this.messageId +
      "]"
    );
  }

  public validateInbound(): void {}

  public validateOutbound(): void {}
}
